import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Box, Button } from '@bonusly/design-system';
import { useFeatureFlag, useIsBizyEnabledForUser } from '@bonusly/who-am-i';

export const OnboardingReplaySection = () => {
	const { t } = useTranslation('bizy_settings', { keyPrefix: 'onboardingReplay' });
	const isBizyEnabledForUser = useIsBizyEnabledForUser();
	const isOnboardingFlagEnabled = useFeatureFlag('bizy-onboarding');
	const navigate = useNavigate();

	if (!isBizyEnabledForUser || !isOnboardingFlagEnabled) return null;

	const handleClick = () => {
		// Navigate ONLY — no store writes here. Router v6 navigations are
		// startTransition-deferred, so a same-tick panel-store change makes
		// useBizyRouteSync observe the close against the STALE location (still
		// ?bizy=settings) and issue its own replace-navigate on the old pathname,
		// clobbering this push. BizyOnboarding's mount effect closes the panel +
		// settings modal once the route (with no ?bizy= param) has landed.
		navigate('/bizy-onboarding?card=1');
	};

	return (
		// Same vertical padding as the PreferenceSettingRows above so the link
		// doesn't sit flush against the previous row's border.
		<Box py={3}>
			<Button variant="link" colorScheme="secondary" size="sm" onClick={handleClick}>
				{t('link')}
			</Button>
		</Box>
	);
};
